import React, { useEffect } from 'react';
import './campos-componente-galeria.component.scss';
import { Button, FormControl, FormControlLabel, FormLabel, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { useInput } from '../../hooks/useInput.hook';
import { ItensMenuModel } from '../../models/menu.model';
import Checkbox from '@mui/material/Checkbox';
import DeleteIcon from '@mui/icons-material/Delete';
import { SalvarPainelService } from '../../services/salvar-painel.service';
import SessaoModel from '../../models/sessao.model';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { CONSTANTS } from '../../constants/constants';
import AttachmentModalComponent from '../attachment-modal/attachment-modal.component';
import { ComponentsModel } from '../../models/layout.model';
import IDsMenuSelectComponent from '../ids-menu-select/ids-menu-select.component';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import OpenWithIcon from '@mui/icons-material/OpenWith';
import Accordion from '@mui/material/Accordion';
import AddIcon from '@mui/icons-material/Add';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import GaleriaModel, { ItensGaleria } from '../../models/galeria.model';
import CamposItemGaleriaComponent from '../campos-item-galeria/campos-item-galeria.component';


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

type CamposComponenteGaleriaComponentProps = {
  setVal: (val: ComponentsModel) => void;
  removeItem: (id?: string) => void;
  componente?: ComponentsModel;
  menu: ItensMenuModel[];
}

function CamposComponenteGaleriaComponent(props: CamposComponenteGaleriaComponentProps) {

  const [idInput, setIdInput] = React.useState(props.componente?.galeria ? props.componente.galeria.id : '');
  const [tituloInput, setTituloInput] = React.useState(props.componente?.galeria ? props.componente.galeria?.titulo : '');
  const [descricaoInput, setDescricaoInput] = React.useState(props.componente?.galeria ? props.componente.galeria?.descricao : '');
  const [bgInput, setBgInput] = React.useState(props.componente?.galeria ? props.componente.galeria?.bg : '');
  const [corDoTituloInput, setCorDoTituloInput] = React.useState(props.componente?.galeria ? props.componente.galeria?.cor_do_titulo : '');
  const [corDoTextoInput, setCorDoTextoInput] = React.useState(props.componente?.galeria ? props.componente.galeria?.cor_do_texto : '');
  const [itensGaleria, setItensGaleria] = React.useState<any>(props.componente?.galeria ? props.componente.galeria?.itens : []);

  const [valueTab, setValueTab] = React.useState(0);

  useEffect(() => {
    handleChangeItem();
  }, [itensGaleria]);

  const handleChangeItem = () => {
    props.setVal({
      id: props.componente?.id,
      tipo: CONSTANTS.TIPO_COMPONENTE.GALERIA,
      galeria: {
        id: idInput,
        titulo: tituloInput,
        descricao: descricaoInput,
        itens: itensGaleria,
        bg: bgInput,
        cor_do_titulo: corDoTituloInput,
        cor_do_texto: corDoTextoInput
      }
    });
  };

  // Carrossel
  const addCarrossel = () => {
    const items = [...itensGaleria];
    const newItem: ItensGaleria = {
      id: 'item_galeria-' + itensGaleria.length,
      src: '',
      width: 0,
      height: 0
    };

    items.push(newItem);

    setItensGaleria(items);
  };

  const handleOnDragEndGaleria = (result: any) => {

    const items = Array.from(itensGaleria);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setItensGaleria(items);
  }

  const handleChageItemGaleria = (item: ItensGaleria) => {

    const items = [...itensGaleria];
    const itemEncontrado: ItensGaleria = items.find(
      a => a.id === item.id
    );
    itemEncontrado.src = item.src;
    itemEncontrado.width = item.width;
    itemEncontrado.height = item.height;

    setItensGaleria(items);
  }

  const removerItemCarrossel = (id?: string) => {
    setItensGaleria(
      itensGaleria.filter(a =>
        a.id !== id
      )
    );
  }
  // Fim Carrossel

  return (
    <section className="campos-componente-galeria">
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={valueTab}
            onChange={(event: React.SyntheticEvent, newValue: number) => setValueTab(newValue)}
            aria-label="basic tabs example">
            <Tab label="Geral" {...a11yProps(0)} />
            <Tab label="Estilo" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={valueTab} index={0}>
          <h2>Geral</h2>
          {
            (props.menu.length && props.componente) &&
            <div className="campo w100">
              <IDsMenuSelectComponent val={props.componente?.galeria?.id} menus={props.menu} setVal={(val) => setIdInput(val)} />
            </div>
          }
          <div className="campo w100">
            <TextField value={tituloInput} onChange={(event) => setTituloInput(event.target.value)} label="Título" />
          </div>
          <div className="campo w100">
            <TextField rows={3} multiline value={descricaoInput} onChange={(event) => setDescricaoInput(event.target.value)} label="Descrição" />
          </div>
          <h2>Imagens da galeria</h2>
          <DragDropContext onDragEnd={handleOnDragEndGaleria}>
            <Droppable droppableId="itens-menus">
              {(provided) => (
                <div className="itens-menus" {...provided.droppableProps} ref={provided.innerRef}>
                  {
                    itensGaleria?.map((item, iMenu) => (
                      <Draggable key={item.id} draggableId={item.id} index={iMenu}>
                        {(provided) => (
                          <Accordion ref={provided.innerRef} {...provided.draggableProps} >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls={item.id + '-content'}
                              id={item.id + '-header'}
                              {...provided.dragHandleProps}
                            >
                              <div className="bar-com-thumb flex flex-sp flex-cv">
                                <Typography component="span">
                                  <OpenWithIcon /> Item galeria
                                </Typography>
                                {
                                  item.src &&
                                  <img src={item.src} alt="thumb" />
                                }
                              </div>
                            </AccordionSummary>
                            <AccordionDetails>
                              <CamposItemGaleriaComponent
                                index={iMenu}
                                itemGaleria={item}
                                setVal={(val) => handleChageItemGaleria(val)}
                                removeItem={(id) => removerItemCarrossel(id)}
                              />
                            </AccordionDetails>
                          </Accordion>
                        )}
                      </Draggable>
                    ))
                  }
                </div>
              )}
            </Droppable>
          </DragDropContext>
          <div className="bts">
            <Button className='bt add' onClick={addCarrossel}><AddIcon />Adicionar item</Button>
            {/* <Button className='bt remove' onClick={() => props.removeItem(props.menusFooter?.id)}><DeleteIcon /> Remover menu</Button> */}
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTab} index={1}>
          <h2>Estilo da galeria</h2>
          <label className='w50'>
            <span>Cor de fundo:</span>
            <input type='color' value={bgInput} onChange={(val) => setBgInput(val.currentTarget.value)} />
          </label>
          <label className='w50'>
            <span>Cor do título:</span>
            <input type='color' value={corDoTituloInput} onChange={(val) => setCorDoTituloInput(val.currentTarget.value)} />
          </label>
          <label className='w50'>
            <span>Cor do texto:</span>
            <input type='color' value={corDoTextoInput} onChange={(val) => setCorDoTextoInput(val.currentTarget.value)} />
          </label>
        </CustomTabPanel>
      </Box>

      <div className="bts">
        <Button className='bt remove' onClick={() => props.removeItem(props.componente?.id)}><DeleteIcon /> Remover galeria</Button>
      </div>
    </section>
  );
}

export default CamposComponenteGaleriaComponent;
